<template>
  <!--所有页面的底部5大导航tab-->
  <van-tabbar v-model="active" @change="onChange" active-color="#000" inactive-color="#000" id="tabbar">
    <van-tabbar-item>
      <span>首页</span>
      <template #icon="props">
        <img :src="props.active ? icon.active : icon.inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span>灯云金融</span>
      <template #icon="props">
        <img :src="props.active ? serviceIcon.active : serviceIcon.inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span>订单</span>
      <template #icon="props">
        <img :src="props.active ? orderIcon.active : orderIcon.inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span>购物车</span>
      <template #icon="props">
        <img :src="props.active ? carIcon.active : carIcon.inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span>我的</span>
      <template #icon="props">
        <img :src="props.active ? woIcon.active : woIcon.inactive" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  name: 'tabBar',
  data () {
    return {
      home: require('@/assets/'+ this.$store.state.appTheme +'/tab_home_active.png'),
      icon: {
        active: require('@/assets/'+ this.$store.state.appTheme +'/tab_home_active.png'),
        inactive: require('@/assets/'+ this.$store.state.appTheme +'/tab_home.png'),
      },
      woIcon: {
        active: require('@/assets/'+ this.$store.state.appTheme +'/tab_wo_active.png'),
        inactive: require('@/assets/'+ this.$store.state.appTheme +'/tab_wo.png'),
      },
      orderIcon: {
        active: require('@/assets/'+ this.$store.state.appTheme +'/tab_order_active.png'),
        inactive: require('@/assets/'+ this.$store.state.appTheme +'/tab_order.png'),
      },
      carIcon: {
        active: require('@/assets/'+ this.$store.state.appTheme +'/tab_car_active.png'),
        inactive: require('@/assets/'+ this.$store.state.appTheme +'/tab_car.png'),
      },
      serviceIcon: {
        active: require('@/assets/'+ this.$store.state.appTheme +'/tab_service_active.png'),
        inactive: require('@/assets/'+ this.$store.state.appTheme +'/tab_service.png'),
      }
    }
  },
  computed: {
    active: {
      get () {
        // 获取当前路由的路径,主要用于选中哪一个tabbar
        const path = this.$route.path
        switch (path) {
          case '/':
            return 0
          case '/service':
            return 1
          case '/order':
            return 2
          case '/cart':
            return 3
          case '/user':
            return 4
          default:
            return -1
        }
      },
      set () {
      }
    }
  },
  methods: {
    // tabbar改变切换页面
    onChange (index) {
      switch (index) {
        case 0:
          this.$router.push('/')
          break
        case 1:
          window.location.href = 'https://jpzs-zst.itos.cn/formBillApply'
          //this.$router.push('/service')
          break
        case 2:
          this.$router.push('/order')
          break
        case 3:
          this.$router.push('/cart')
          break
        case 4:
          this.$router.push('/user')
          break
      }
    }
  }
}
</script>

<style scoped>

</style>
